export default __webpack_public_path__ + "static/media/ai_motion.87ed059b.svg";